import { gql } from '@apollo/client'

// The variable must be named $propertyCode. The BFF decodes an encoded ID (acc_…) only
// in variables whose name ends in id/code/number, so under the old name $input the raw
// token reached the asset service, matched no accommodation, and every saved facility
// came back unselected.
export const ACCOMMODATION_FACILITIES_QUERY = gql`
  query GetAccommodationFacilities($propertyCode: String!) {
    getAccommodationFacilities(propertyCode: $propertyCode) {
      label
      facilities {
        label
        value
        id
        description
        selected
      }
    }
  }
`
